import { Routes, Route, useLocation } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { useEffect } from 'react'
import './App.css'
import TopAppBar from './components/TopAppBar'
import Main from './components/main/Main'
import Blog from './components/blog/Blog'
import YearEnd from './components/blog/contents/YearEnd'
import SmartThings from './components/blog/contents/SmartThings'
import OrganizeThoughts from './components/blog/contents/OrganizeThoughts'
import EngineerToPM from './components/blog/contents/EngineerToPM'
import TwoCountriesTwoLives from './components/blog/contents/TwoCountriesTwoLives'
import TwoLanguage from './components/blog/contents/TwoLanguage'
import Connections from './components/blog/contents/Connections'
import PalantirRedefiningTheProblem from './components/blog/contents/PalantirRedefiningTheProblem'
import DataIsTheOxygenOfAi from './components/blog/contents/DataIsTheOxygenOfAi'
import Family from './components/blog/contents/Family'
import BeforeThirty from './components/blog/contents/BeforeThirty'
import Testimonials from './components/testimonials/Testimonials'
import Faq from './components/faq/Faq'
import Books from './components/books/Books'
import Writing from './components/writing/Writing'
import WritingPending from './components/writing/WritingPending'
import ScrollToTop from './components/ScrollToTop'
import Footer from './components/Footer'
import PageContainer from './components/layouts/PageContainer'

function App () {
  const location = useLocation();

  useEffect(() => {
    // Send pageview event to Google Analytics
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search
      });
    }
  }, [location]);

  return (
    <HelmetProvider>
      <div className='App'>
        <ScrollToTop />
        <TopAppBar />

        <PageContainer>
          <Routes>
            <Route path='/' element={<Main />} />
            <Route path='blog' element={<Blog />} />
            <Route path='blog/organize-thoughts' element={<OrganizeThoughts />} />
            <Route path='blog/year-end' element={<YearEnd />} />
            <Route path='blog/smartthings' element={<SmartThings />} />
            <Route path='blog/engineer-to-pm' element={<EngineerToPM />} />
            <Route path='blog/two-countries-two-lives' element={<TwoCountriesTwoLives />} />
            <Route path='blog/two-language' element={<TwoLanguage />} />
            <Route path='blog/connections' element={<Connections />} />
            <Route path='blog/palantir-redefining-the-problem' element={<PalantirRedefiningTheProblem />} />
            <Route path='blog/data-is-the-oxygen-of-ai' element={<DataIsTheOxygenOfAi />} />
            <Route path='blog/family' element={<Family />} />
            <Route path='blog/before-thirty' element={<BeforeThirty />} />
            <Route path='testimonials' element={<Testimonials />} />
            <Route path='faq' element={<Faq />} />
            <Route path='books' element={<Books />} />
            <Route path='writing' element={<Writing />} />
            <Route path='writing-pending' element={<WritingPending />} />
          </Routes>

          <Footer />
        </PageContainer>
      </div>
    </HelmetProvider>
  )
}

export default App
